import { useNavigation } from '@/hooks/useNavigation'
import { useDispatch } from 'react-redux'

import { HStack } from '@chakra-ui/react'

import { DrawerBreadcrumb } from '@/components/ui'
import { FacilityType } from '@/graphql/generated/schemas'
import { openDeviceDrawer, setDevice } from '@/redux/ui/uiSlice'
import { getArchivedLabel } from '@/utils/formats'

import { IncidentDataType } from '../types/types'

export interface IncidentLocationIProps {
  incident: IncidentDataType
  isLoading: boolean
  onClose: () => void
}

export const IncidentLocationInfo = ({
  incident,
  onClose,
  isLoading,
}: IncidentLocationIProps) => {
  const device = incident?.devices?.[0]

  const isArchived = incident?.facility?.archived

  const facilityFullName = incident?.facility?.name
  const facilityShortName = incident?.facility?.shortName

  const floorLabel = `Floor ${incident?.floor?.name}`
  const deviceName = device?.name
  const onFloorPlanOpen = () => {
    onClose()
    goToFloorPlan(incident?.floor?.id)
  }

  const dispatch = useDispatch()
  const { goToFloorPlan } = useNavigation()

  const isNormalIncident = incident?.facility?.type === FacilityType.Normal

  const onDeviceDrawerOpen = () => {
    dispatch(setDevice({ id: device?.id, type: device?.type }))
    dispatch(openDeviceDrawer())
  }

  const fontSize = '14px'

  // Hacky, but makes it so that each section is as greedy as possible
  const madWidth = '100%'

  return (
    <HStack align='start' spacing={2}>
      {/* region Device */}
      <DrawerBreadcrumb
        dataTestId='incidentDrawer_header_deviceName'
        disabled={isArchived}
        fontSize={fontSize}
        hideDivider={false}
        isLoading={isLoading}
        isTruncated={true}
        label={deviceName}
        maxWidth={madWidth}
        onClick={onDeviceDrawerOpen}
        tooltipLabel={getArchivedLabel(deviceName, isArchived)}
      />
      {/* endregion */}

      {/* region Floor */}
      <DrawerBreadcrumb
        dataTestId='incidentDrawer_header_floor'
        disabled={isArchived}
        fontSize={fontSize}
        hideDivider={false}
        isLoading={isLoading}
        isTruncated={true}
        label={floorLabel}
        maxWidth={madWidth}
        onClick={onFloorPlanOpen}
        tooltipLabel={getArchivedLabel(floorLabel, isArchived)}
      />
      {/* endregion */}

      {/* region Facility */}
      {/* b/c we're only using Facility short code we want this to be the "greediest" and not be truncated b/c it can't even be that big */}
      <DrawerBreadcrumb
        dataTestId='incidentDrawer_header_facilityShortName'
        disabled={isArchived}
        fontSize={fontSize}
        hideDivider={true}
        isLoading={isLoading}
        isTruncated={false}
        label={facilityShortName}
        maxWidth={madWidth}
        // TODO - Feels like clicking the Facility should behave as if you
        //  clicked on the Facility from the Facility tab (i.e. take you to
        //  default floor). As it currently works we have two buttons side by
        //  side that do the exact samet thing
        onClick={isNormalIncident ? onFloorPlanOpen : undefined}
        tooltipLabel={getArchivedLabel(facilityFullName, isArchived)}
      />
      {/* endregion */}
    </HStack>
  )
}
